import { render } from "./ChargebeeUpsellMarketingItemEmailPack.vue?vue&type=template&id=cc10cede&scoped=true"
import script from "./ChargebeeUpsellMarketingItemEmailPack.vue?vue&type=script&lang=js"
export * from "./ChargebeeUpsellMarketingItemEmailPack.vue?vue&type=script&lang=js"

import "./ChargebeeUpsellMarketingItemEmailPack.vue?vue&type=style&index=0&id=cc10cede&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc10cede"]])

export default __exports__